import { Alert, Spinner } from 'flowbite-react';
import { HiInformationCircle } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { Context, PropsWithChildren, useCallback, useEffect, useState } from 'react';

interface LoadableContextProps<T> extends PropsWithChildren {
    name: string;
    context: Context<T | undefined>;
    loader: () => Promise<T>;
}

export default function LoadableContext<T> ({context, name, loader, children}: LoadableContextProps<T>) {
    const { t } = useTranslation('shared');
    const [value, setValue] = useState<T | undefined>(undefined)
    const [error, setError] = useState<string | undefined>(undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loaderCallback = useCallback(() => loader(), [])

    useEffect(() => {
        loaderCallback()
            .then(value => setValue(value))
            .catch(error => setError(JSON.stringify(error.toString())))
    }, [loaderCallback]);


    if (value == undefined) {
        if (error === undefined) {
            return (
                <div className="flex justify-center p-8">
                    <Spinner aria-label={t('loading')} size="xl"/>
                </div>
            )
        } else {
            return (
                <div className="p-8">
                    <Alert color="failure" icon={HiInformationCircle}>
                        <span className="font-medium">{name}: {error}</span> {t('retry')}
                    </Alert>
                </div>
            )
        }
    } else {
        return (
            <context.Provider value={value}>
                {children}
            </context.Provider>
        )
    }
}

